import curry from "../../../lib/core/functional/curry";

const renderModule = curry(function renderPostReviewModule(
    { h, Fragment, hooks },
    _context,
    { Review },
    _altLoader
) {
    const { useState, useEffect } = hooks;
    function PostReview(props) {
        const { poll } = props;
        const [rating, setRating] = useState(poll.reactions.rating.stars.total || 0);

        useEffect(() => {
            if (poll.reactions.rating.stars.total) {
                setRating(poll.reactions.rating.stars.total);
            }
        }, [poll.reactions.rating.stars.total]);

        const count = poll.reactions.rating.stars.count;

        return (
            <Fragment>
                Reviews:
                <span class="talk__review_summary">
                    <Review enabled score={rating/(count || 1)} /> ({count})
                </span>
            </Fragment>
        );
    }
    return PostReview;
});

export default function review({ preact }) {
    return renderModule(preact);
}
